export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-[#0a0a0f] border-t border-white/10 overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[400px] h-px bg-gradient-to-r from-transparent via-[#d4af37]/40 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div>
            <img
              src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/caaea5a1b17e64d200d3c08d14d4a01f.png"
              alt="Nova Güzellik Lounge"
              className="h-10 w-auto object-contain mb-4"
            />
            <p className="text-white/40 text-sm leading-relaxed max-w-xs">
              Kampanya odaklı, dönüşüm optimize edilmiş premium güzellik platformu.
            </p>
            <div className="flex items-center gap-3 mt-5">
              {['ri-instagram-line', 'ri-facebook-circle-line', 'ri-tiktok-line', 'ri-whatsapp-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/10 text-white/40 hover:text-[#d4af37] hover:border-[#d4af37]/40 transition-all duration-200 cursor-pointer"
                >
                  <i className={`${icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-5">Hızlı Erişim</h4>
            <div className="flex flex-col gap-3">
              {[
                { label: 'Nasıl Çalışır', id: 'nasil-calisir' },
                { label: 'Kampanyalar', id: 'kampanyalar' },
                { label: 'Yönetim Paneli', id: 'yonetim-paneli' },
                { label: 'Reklam Modülü', id: 'reklam-siparis' },
                { label: 'Karşılaştırma', id: 'karsilastirma' },
                { label: 'İletişim', id: 'iletisim' },
              ].map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollTo(item.id)}
                  className="text-white/40 hover:text-[#d4af37] text-sm text-left transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-5">İletişim</h4>
            <div className="flex flex-col gap-3">
              {[
                { icon: 'ri-map-pin-line', text: 'Bağcılar, İstanbul' },
                { icon: 'ri-phone-line', text: '+90 500 123 45 67' },
                { icon: 'ri-time-line', text: 'Pzt–Cmt: 09:00–20:00' },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-2 text-white/40 text-sm">
                  <i className={`${item.icon} text-[#d4af37] text-base`}></i>
                  {item.text}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/20 text-xs">© 2026 Nova Güzellik Lounge. Tüm hakları saklıdır.</p>
          <div className="flex items-center gap-1 text-white/20 text-xs">
            <i className="ri-shield-check-line text-[#d4af37]/40"></i>
            <span>Smart Pro Platform ile güçlendirilmiştir</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
